import { render, staticRenderFns } from "./dictManage.vue?vue&type=template&id=4b2bcdde&scoped=true&"
import script from "./dictManage.vue?vue&type=script&lang=js&"
export * from "./dictManage.vue?vue&type=script&lang=js&"
import style0 from "./dictManage.vue?vue&type=style&index=0&id=4b2bcdde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2bcdde",
  null
  
)

export default component.exports